var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexmap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.756 18.903V13.51H9.822c-.974 0-1.736.238-2.285.714-.542.469-.813 1.128-.813 1.977 0 .857.271 1.524.813 2 .542.469 1.304.703 2.285.703h2.934zm-2.527 2.263L6.24 27H3.055l4.306-6.23c-1.069-.307-1.926-.867-2.57-1.68-.645-.813-.967-1.78-.967-2.9 0-1.502.505-2.718 1.516-3.648 1.01-.93 2.344-1.395 3.999-1.395h6.23V27h-2.813v-5.834h-2.527zm9.318 6.065c-.513 0-.934-.165-1.264-.495-.33-.33-.494-.743-.494-1.241 0-.506.165-.92.494-1.242.33-.33.751-.494 1.264-.494.52 0 .941.165 1.263.494.33.323.495.736.495 1.242 0 .498-.165.912-.495 1.241-.322.33-.743.495-1.263.495zm6.802-9.273h.484l5.954-6.811h3.252l-6.8 7.712L36.544 27h-3.493l-6.207-6.79h-.495V27h-2.834V11.147h2.834v6.811z",
    fill: "#F43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 8.458 0 4.686 2.343 2.343S8.458 0 16 0h8c7.543 0 11.314 0 13.657 2.343S40 8.458 40 16v8c0 7.543 0 11.314-2.343 13.657S31.543 40 24 40h-8c-7.542 0-11.314 0-13.657-2.343S0 31.543 0 24v-8z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexmap);
export default __webpack_public_path__ + "static/media/yandexmap.cad4520242c3b7ec332fe56c6916749c.svg";
export { ForwardRef as ReactComponent };